import { apiResponseToFields } from 'modules/Cube/communication/external/quotes.api.v1/adapters/quote.adapters.in'
import { domainToApi } from 'modules/Cube/communication/external/quotes.api.v1/adapters/quote.adapters.out'

export const quoteAdapters = {
  in: apiResponseToFields,
  out: domainToApi
}
